import { Controller } from "stimulus";
import $ from "jquery";
import "select2"
import {buildEditableSelect, getHtmlElement, isDefined} from "../utils/utils";

export default class extends Controller {
    static targets = [ "brand", "game", "era", "expansion" ];

    initialize() {
        $(document).on("turbolinks:before-cache", function() {
            if ($('.select2-custom')) {
                $(".select2-custom").select2("destroy");
            }
        });

        $(document).on('turbolinks:load', function() {
            $('.select2-custom').select2();
        });

        buildEditableSelect(null);

        if (isDefined(this.gameTarget.value))
            this.getErasAndExpansions();
    }

    // Funzione per ottenere tutti i games che matchano con il brand eventualmente specificato
    // dall'utente sull'interfaccia grafica
    getGames() {
        const url = `/games_for_filters?brand_id=${this.brandTarget.value}`;

        while (this.gameTarget.lastElementChild) {
            this.gameTarget.removeChild(
              this.gameTarget.lastElementChild
            );
        }

        this.gameTarget.insertAdjacentHTML(
          "beforeend",
          "<option value>Select game</option>"
        );

        while (this.eraTarget.lastElementChild) {
            this.eraTarget.removeChild(
              this.eraTarget.lastElementChild
            );
        }

        this.eraTarget.insertAdjacentHTML(
          "beforeend",
          "<option value>Select era</option>"
        );

        while (this.expansionTarget.lastElementChild) {
            this.expansionTarget.removeChild(
              this.expansionTarget.lastElementChild
            );
        }

        this.expansionTarget.insertAdjacentHTML(
          "beforeend",
          "<option value>Select expansion</option>"
        );


        if (isDefined(this.brandTarget.value))
            $.ajax({
                url: url,
                dataType: "json",
                success: (games) => {
                    for (const game of games) {
                        this.gameTarget.insertAdjacentHTML(
                          "beforeend",
                          `<option value='${game.id}' ${game.id == getHtmlElement(document, 'game_filter')?.innerHTML ? 'selected' : ''}>` + game.name + "</option>"
                        );
                    }
                },
            });
    }

    // Funzione per ottenere tutte le expansions che matchano con il game e l'era, eventualmente specificati
    // dall'utente sull'interfaccia grafica
    getExpansions() {
        const url = `/expansions_for_filters?game_id=${this.gameTarget.value}&era_id=${this.eraTarget.value}&include_fakes=true&return_name=encoded_name`;

        while (this.expansionTarget.lastElementChild) {
            this.expansionTarget.removeChild(
              this.expansionTarget.lastElementChild
            );
        }

        this.expansionTarget.insertAdjacentHTML(
          "beforeend",
          "<option value>Select expansion</option>"
        );

        if (isDefined(this.gameTarget.value) && isDefined(this.eraTarget.value))
            $.ajax({
                url: url,
                dataType: "json",
                success: (expansions) => {

                    for (const expansion of expansions) {
                        this.expansionTarget.insertAdjacentHTML(
                          "beforeend",
                          `<option value='${expansion.id}' ${expansion.icon ? 'label=' + expansion.icon : ''} ${expansion.id == getHtmlElement(document, 'expansion_filter')?.innerHTML ? 'selected' : ''}>` + expansion.name + "</option>"
                        );
                    }
                },
            });
    }


    // Funzione per ottenere tutte le ere e le expansions che matchano con il game eventualmente specificato
    // dall'utente sull'interfaccia grafica
    getErasAndExpansions() {
        const url = `/eras_for_filters?game_id=${this.gameTarget.value}&include_fakes=true`;

        while (this.eraTarget.lastElementChild) {
            this.eraTarget.removeChild(
              this.eraTarget.lastElementChild
            );
        }

        this.eraTarget.insertAdjacentHTML(
          "beforeend",
          "<option value>Select era</option>"
        );

        while (this.expansionTarget.lastElementChild) {
            this.expansionTarget.removeChild(
              this.expansionTarget.lastElementChild
            );
        }

        this.expansionTarget.insertAdjacentHTML(
          "beforeend",
          "<option value>Select expansion</option>"
        );

        if (isDefined(this.gameTarget.value))
            $.ajax({
                url: url,
                dataType: "json",
                success: (eras) => {
                    for (const era of eras) {
                        this.eraTarget.insertAdjacentHTML(
                          "beforeend",
                          `<option value='${era.id}' ${era.id == getHtmlElement(document, 'era_filter')?.innerHTML ? 'selected' : ''}>` + era.name + "</option>"
                        );
                    }

                    if (this.targets.find("expansion"))
                        this.getExpansions();
                },
            });
    }


    // Funzione per ottenere tutte le ere che matchano con il game eventualmente specificato
    // dall'utente sull'interfaccia grafica
    getEras() {
        const url = `/eras_for_filters?game_id=${this.gameTarget.value}&include_fakes=true`;

        while (this.eraTarget.lastElementChild) {
            this.eraTarget.removeChild(
              this.eraTarget.lastElementChild
            );
        }

        this.eraTarget.insertAdjacentHTML(
          "beforeend",
          "<option value>Select era</option>"
        );

        if (isDefined(this.gameTarget.value))
            $.ajax({
                url: url,
                dataType: "json",
                success: (eras) => {
                    for (const era of eras) {
                        this.eraTarget.insertAdjacentHTML(
                          "beforeend",
                          `<option value='${era.id}' ${era.id == getHtmlElement(document, 'era_filter')?.innerHTML ? 'selected' : ''}>` + era.name + "</option>"
                        );
                    }
                },
            });
    }
}